<template>
  <div class="main">
    <el-container>
      <el-header>
        <div class="header-content">
          <div class="header-left">
            <div class="logo"  :style="{backgroundImage:'url('+imagesPath+')'}" ></div>
          </div>
          <div class="header-right">
            <div class="user-info ">
              <p ><span class="user-info-name"> 欢迎回来,<span class="name">{{userData.name}}</span></span></p>
            </div>
            <div class="contact">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <img src="../images/home/namtou.jpg" alt="">
                  <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
                  <el-dropdown-item @click.native="logOut">退出账号</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
      <!-- 修改密码弹窗 -->
      <el-dialog title="修改密码" @close="toClose" :close-on-click-modal="false"  :visible.sync="dialogFormVisible"   class="change-password" width="500px">
        <el-form ref="resetPwd"  :model="form" :rules="rules">
          <el-form-item label="原始密码："  :label-width="formLabelWidth" prop="oldPassword">
            <el-input v-model.trim="form.oldPassword" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码："  :label-width="formLabelWidth" prop="newPassword">
            <el-input v-model.trim="form.newPassword" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" :label-width="formLabelWidth" prop="confirmPassword" class="tips">
            <el-input v-model.trim="form.confirmPassword"  type="password" autocomplete="off"></el-input>
            <div class="change-password">密码必须包含数字、小写字母、大写字母不包含特殊字符 且长度不低于6位</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="loading" @click="submitResetPwd">保 存</el-button>
        </div>
      </el-dialog>
      <el-container class="main-wrap">
        <el-aside class="main-bar">
          <side-bar
            :menu-list="menuList"
            :open-names="openedSubmenuArr"
            :current-page="getCurrentPageName"></side-bar>
        </el-aside>
        <el-main class="main-content">
          <keep-alive>
            <!-- meta自定义keepAlive属性决定哪些页面会被缓存 -->
            <router-view v-if="$route.meta && $route.meta.keepAlive"></router-view>
          </keep-alive>
          <!-- 当meta中keepAlive为true的时候不会被缓存 -->
          <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
        </el-main>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { updatePassword } from '../api/login'
import SideBar from './components/SideBar'
import { getUserInfo } from '@/utils/auth'
export default {
  data () {
    // 密码验证 密码必须包含数字、小写字母、大写字母 且长度不低于6位
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else {
        let reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{6,16}$/;
        if (!reg.test(value)) { callback(new Error('密码格式不对')) } else {
          callback()
        }
      }
    };
    // 验证两次密码是否一致
    let validateCheckPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      // 图片地址
      imagesPath: '',

      infoVisible: false,
      userData: getUserInfo(),

      dialogFormVisible: false,
      // 用户信息
      formLabelWidth: '100px',
      userName: '',
      menuList: [],
      openedSubmenuArr: [],
      rules: {
        oldPassword: [
          { required: true, message: '请输入原来密码', trigger: 'blur' },
          { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateCheckPassword, trigger: 'blur' }
        ]
      },
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      loading: false
    }
  },
  components: {
    SideBar
  },
  computed: {
    getCurrentPageName () {
      return this.$store.state.app.currentPageName;
    }
  },
  beforeMount () {
    this.init();
  },
  methods: {
    toClose () {
      this.$refs.resetPwd.resetFields();
    },
    init () {
      // 权限菜单过滤相关
      this.$store.commit('updateMenulist');
      this.menuList = this.$store.state.app.menuList;
      this.openedSubmenuArr = this.$store.state.app.openedSubmenuArr;
    },
    // 点击修改密码  修改密码弹窗出现
    changePassword () {
      this.dialogFormVisible = true;
    },
    // 提交表单
    submitResetPwd () {
      this.$refs['resetPwd'].validate((valid) => {
        if (!valid) {
          return;
        } else {
          if (this.form.oldPassword === this.form.newPassword) {
            this.$message.error('新密码不能与旧密码相同');
            return;
          }
        }
        updatePassword(this.form).then(res => {
          if (res.status === 200) {
            this.$message.success('密码修改成功')
            this.dialogFormVisible = false;
            this.$router.push({ path: '/login' });
          } else {
            this.$message.error(res.message || '密码修改失败');
          }
        }).catch()
        this.loading = true;
      });
    },
    logOut () {
      // 退出登录
      this.$store.commit('logout', this);
      this.$store.commit('clearOpenedSubmenu');
      if (this.socketio) {
        this.socketio.disconnect();
        this.socketio = null;
      }
      this.$router.push({
        name: 'login'
      });
    }
  }
}
</script>
<style lang="less">
.main {
  .el-header {
    height: 90px !important;
    padding: 0;
    background-color: #fff;
    box-shadow:0px 6px 12px 0px rgba(230,233,240,0.3);
  }
  .header-content {
    display: flex;
    .header-left {
      width: 220px;
      height: 90px;
      display: flex;
      background-color: #354052;
      .logo{
        width: 100%;
        height: 90px;
        background: url('../images/home/logo_home.png') center center no-repeat #5A75F6;
      }
      .title{
        height: 90px;
        line-height: 90px;
        padding-left: 13px;
        font-size:18px;
        font-weight:500;
        color: #ffffff;
      }
    }
    .header-right {
      box-sizing: border-box;
      width: calc(~"100% - 220px");
      padding:30px 40px;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-content: space-between;
      text-align: justify;
      .user-info {
        height: 30px;
        line-height: 30px;
        display: flex;
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .user-info-name{
          font-size: 16px;
          font-weight: bold;
          color: #333;
          .name {
            color: #5A75F6;
          }
        }
      }
      .contact{
        display: flex;
        justify-content: center;
        align-items: center;
        .messageAlert{
          cursor: pointer;
          margin-right:40px;
          padding-top: 5px;
          i{
            font-size: 20px;
            font-weight: 600;
          }
        }
        .call-center {
          flex-shrink:0;
          width: 84px;
          height: 30px;
          line-height: 30px;
          img {
            width: 17px;
            height: 14px;
          }
        }
        .el-dropdown {
          line-height: 30px;
          .el-dropdown-link {
            height: 50px;
            display: flex;
            align-items: center;
            img {
              margin-right: 5px;
              width: 30px;
              height: 30px;
            }
          }
        }
      }

    }
  }
  .main-wrap {
    display: flex;
    justify-content: space-between;
    .main-bar {
      width: 220px !important;
      background-color: #354052;
    }
    .main-content {
      // height: calc(100vh - 110px);
      overflow-y: auto;
      flex: 1;
      background-color: #F4F5FA;
      padding: 0;
    }
  }
}
.el-popover {
  left: 100px;
  padding: 0;
}
.info-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .btns-left {
    .el-badge {
      margin: 0 10px;
    }
    .el-button--text {
      padding: 12px 20px;;
    }
  }
  .btns-right {
    .el-input {
      width: 120px;
      .el-input__inner {
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
      }
    }
  }
}
.footer-info {
  display: flex;
  height: 60px;
  justify-content: center;
  width: 100%;
  .footer-content {
    display: flex;
    align-items: center;
  }
  .line {
    width: 110px;
    border-bottom: 1px solid #ECECEC;
  }
  .text {
    width: 190px;
    text-align: center;
    font-size: 12px;
    color: #253B61;
  }
}
.message-info {
  display: flex;
  flex-direction: column;
  width: 340px;
  .message-title {
    height: 50px;
    line-height: 50px;
    color: #333;
    padding-left: 16px;
    font-weight: bold;
    border-bottom: 1px solid #C9C9C9;
  }
  ul {
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow-y: auto;
    li {
      padding: 18px 12px 18px 15px;
      border-bottom: 1px solid #ECECEC;
      cursor: pointer;
      &:hover {
        background-color: #EDF6FB;
      }
      .message-header {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        .message-type {
          color: #666666;
        }
        .message-timer {
          color: #999;
        }
      }
      .message-content {
        color: #333;
        margin: 5px 0;
      }
    }
  }
}
  .el-dialog__header {
    background-color: #F7F9FC;
  }
.tips {
  .el-form-item__content {
    line-height: 30px;
    font-size: 12px;
    color: #3D4966;
  }
}
.change-password {
  .el-input {
    width: 300px;
  }
  .el-dialog__footer {
    padding-left: 120px;
    text-align: left;
    margin-top: -30px;
  }
  .change-password {
    width: 300px;
    margin-top: 10px;
    line-height: 22px;
  }
}
.red-circle {
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: #fff;
}
.no-read {
  text-align: center;
  line-height: 50px;
}
.loading-div {
  min-height: 100px;
}
.table-content-div {
  min-height: 100px;
}
.info-list {
  .el-tabs__nav-wrap {
    padding-left: 15px;
  }
  .el-tabs__active-bar {
    width: 35px !important;
  }
}
.info-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 340px;
  color: #787D83;
  font-size: 12px;
  border-top: 2px solid #EBEEF5;
  height: 52px;
  line-height: 52px;
  .read-btn {
    padding-left: 15px;
    cursor: pointer;
  }
  .history-message {
    cursor: pointer;
    padding-right: 15px;
  }
}
.table-content-main {
  .table-content-header {
    display: flex;
    height: 60px;
    line-height: 60px;
    background-color: #F7F9FC;
    font-size: 14px;
    color: #223457;
    font-weight: bold;
  }
  span {
    padding: 0 34px;
  }
  .table-content-ul {
    max-height: 450px;
    overflow-y: auto;
    li {
      display: flex;
      padding: 18px 0;
      border-bottom: 1px solid #ECECEC;
      font-size: 14px;
      color: #223457;
    }
  }
  .gray-color {
      color:  rgba(31, 46, 77, 0.5);
      cursor: text !important;
  }
  .messageContent {
    width: 656px;
    cursor: pointer;
  }
  .messageTime {
    width: 260px;
  }
  .messageType {
    width: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue